<template>
  <div class="wrapper flex flex-col min-h-screen" style="background: var(--va-background-secondary)">
    <header class="flex justify-center p-4">
      <div class="max-w-7xl w-full flex justify-end md:justify-between text-lg">
        <div class="hidden md:block">
          <a href="/">BELIZE IMMIGRATION | Ministry of Immigration</a>
        </div>
        <div><a href="https://immigration.gov.bz/" class="va-link">Back to Belize Immigration Website &#8594;</a></div>
      </div>
    </header>
    <main id="app-main" class="mx-auto py-8 grow">
      <div class="w-full p-4 md:p-0">
        <RouterView v-slot="{ Component }">
          <Transition name="fade" mode="out-in">
            <component :is="Component" />
          </Transition>
        </RouterView>
      </div>
    </main>
    <footer id="footer" class="flex flex-col" style="color: #fff; background: var(--va-primary)">
      <div class="px-20 py-12 flex flex-col gap-10 justify-center">
        <div class="flex justify-center sm:hidden">
          <a href="/">
            <img alt="" src="@/assets/sm_services_portal_logo.png" class="w-96" />
          </a>
        </div>
        <div class="flex flex-col sm:flex-row justify-center gap-10">
          <div class="flex justify-center">
            <a href="https://immigration.gov.bz" target="_blank">
              <img alt="" src="@/assets/It-office-logo-dark-main.png" class="w-56" />
            </a>
          </div>
          <div class="flex justify-center">
            <div>
              <p class="text-[8px]">Payments powered by</p>
              <!-- TODO: need to confirm on link, original link does not work /redirection -->
              <a href="https://placetopay.dev/checkout" target="_blank">
                <img alt="" src="https://static.placetopay.com/placetopay-logo-dark-background.svg" class="w-48" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center text-xs px-6 py-2" style="color: #fff">
        © 2024 Government of Belize | Ministry of Immigration | All Rights Reserved.
      </div>
    </footer>
  </div>
</template>
<script lang="ts" setup></script>
<style>
.wrapper {
  min-height: 100vh;
}
#footer {
  margin-top: 50px;
  position: relative;
}

@media (max-width: 639px) {
  #footer::before {
    content: '';
    position: absolute;
    width: 100%;
    top: -50px;
    background-image: url('@/assets/sm_coat_of_arms.png');
    background-size: 100px 100px;
    height: 100px;
    width: 100%;
    background-repeat: no-repeat;
    background-position-x: center;
  }
}
</style>
